import Vue from 'vue';
import VueRouter from 'vue-router';

import Dashboard from '../views/Dashboard';

import { BILLING_ROUTES } from './billing.routes';
import { PROFILE_ROUTES } from './profile.routes';
import { TOOLS_ROUTES } from './tools.routes';
import { CLIENTS_ROUTES } from './clients.routes';
import { HOUSEHOLD_TOOLS } from './households.routes';
import { AUTH_ROUTES } from './auth.routes';
import { PARTNERSHIP_ADMIN_ROUTES } from './partnership-admin.routes';
import { SYSTEM_ADMIN_ROUTES } from './system-admin.routes';
import { JUMP_START_ROUTES } from './jump-start.routes';
import { EDIT_CLIENT_DATA } from './client-edit.routes';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
    meta: { title: 'Dashboard' }
  },
  AUTH_ROUTES,
  BILLING_ROUTES,
  PROFILE_ROUTES,
  TOOLS_ROUTES,
  CLIENTS_ROUTES,
  HOUSEHOLD_TOOLS,
  PARTNERSHIP_ADMIN_ROUTES,
  SYSTEM_ADMIN_ROUTES,
  JUMP_START_ROUTES,
  EDIT_CLIENT_DATA,
  {
    path: '*',
    redirect: { name: 'dashboard' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
